import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import hidePopupOperation from 'store/app/operation/hidePopupOperation';
import getFrameUpsellData from 'store/product/selector/getFrameUpsellData';
import { PopupPremium, Button } from 'components/Common';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import addToBasketSelectedBundleProductsOperation from 'store/product/operation/addToBasketSelectedBundleProductsOperation';
import getFrameUpsellFrameProductId from 'store/product/selector/getFrameUpsellFrameProductId';
import { nextStepFlowAction } from 'store/app/slice';
import { AvailableFlows, AvailablePopups } from 'store/app/types';
import FrameSelector from './FrameSelector/FrameSelector';
import styles from './FrameUpsellPopup.module.scss';
import ProductPreview from './ProductPreview/ProductPreview';
import VoucherText from './VoucherText/VoucherText';
import FramePrice from './FramePrice/FramePrice';
import FrameDescription from './FrameDescription/FrameDescription';

const FrameSelectorPopup = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const frameProductId = useSelector(getFrameUpsellFrameProductId);
  const popupTitle = useSelector(getFrameUpsellData)?.title || '';

  const closePopup = () => {
    dispatch(hidePopupOperation());
    dispatch(nextStepFlowAction(AvailableFlows.postAddToCart));
  };

  const continueWithoutFrame = () => {
    gtmSendEvent({
      event: 'api_upsell_frames_continue_without_frame',
    });
    closePopup();
  };

  const continueWithFrame = async () => {
    await dispatch(addToBasketSelectedBundleProductsOperation());
    gtmSendEvent({
      event: 'api_upsell_frames_add_frame_to_basket',
    });
    closePopup();
  };

  const buttons = () => (
    <div className={styles.buttonGroup}>
      <Button
        id="continue-without-frame-button"
        onClick={continueWithoutFrame}
        text={t('txt_continue_without_the_frame')}
        className={styles.withoutFrame}
      />
      <Button
        id="add-frame-to-basket-button"
        onClick={continueWithFrame}
        primary
        className={styles.withFrame}
        disabled={frameProductId === 0}
        text={t('txt_button_add_frame_to_the_basket')}
      />
    </div>
  );

  return (
    <PopupPremium
      popupId={AvailablePopups.frameUpsellPopup}
      title={popupTitle}
      onClosePopup={closePopup}
      contentClassName={styles.popupContent}
      headerClassName={styles.header}
      showCloseIcon
    >
      <div className={styles.frameSelectorPopup}>
        <VoucherText />
        <div className={styles.contentRow}>
          <FrameSelector />
          <FramePrice />
        </div>
        <div className={styles.contentRow}>
          <ProductPreview />
        </div>
        <div className={styles.contentRow}>
          <FrameDescription />
        </div>
        <div className={cn(styles.contentRow, styles.sticky)}>{buttons()}</div>
      </div>
    </PopupPremium>
  );
};

export default FrameSelectorPopup;
